module.exports = __webpack_public_path__ + "img/right-arow.87402e73.svg";